import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getTranslations } from "../data/translations/index";
import { useReveal } from "../hooks/useReveal";
import { DownloadButton } from "./DownloadButton";
import { Tabs } from "./Tabs";
import "../styles/EntryCard.css";

export const EducationItem = () => {
  const { language } = useLanguage();
  const { Education, EducationTabs } = getTranslations(language);

  const [activeTab, setActiveTab] = useState(EducationTabs[0].id);
  const rootRef = useRef(null);

  // Beim Sprachwechsel bleiben die ids gleich, der Tab also auch – aber falls
  // die Tab-Liste einmal anders aussieht, darf kein toter Zustand überleben.
  useEffect(() => {
    if (!EducationTabs.some((tab) => tab.id === activeTab)) {
      setActiveTab(EducationTabs[0].id);
    }
  }, [EducationTabs, activeTab]);

  // Sprache UND Tab als Reset-Key: beim Wechsel werden die Karten neu
  // gemountet und müssen erneut beobachtet werden, sonst bleiben sie unsichtbar.
  useReveal(rootRef, `${language}-${activeTab}`);

  const entries = Education.filter((education) => education.tab === activeTab);
  const tabLabel = EducationTabs.find((tab) => tab.id === activeTab)?.label;

  return (
    <div className="entry-list container">
      <Tabs
        tabs={EducationTabs}
        value={activeTab}
        onChange={setActiveTab}
        label={tabLabel}
      />

      <div
        className="entry-list__panel"
        role="tabpanel"
        id={`panel-${activeTab}`}
        aria-labelledby={`tab-${activeTab}`}
        tabIndex={-1}
        ref={rootRef}
      >
        {entries.map((education, index) => (
          <article
            className="entry glass glass--interactive"
            key={education.id}
            data-reveal
            style={{ "--reveal-delay": `${Math.min(index, 4) * 0.06}s` }}
          >
            <div className="entry__aside">
              <a
                className="entry__logo-link"
                href={education.href}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="entry__logo"
                  src={education.src}
                  alt={education.company}
                />
              </a>
              <h3 className="entry__company">{education.company}</h3>
              <p className="entry__location">{education.location}</p>
            </div>

            <div className="entry__main">
              <p className="entry__date">{education.date}</p>
              <h2 className="entry__title">{education.position}</h2>
              <ul className="entry__points">
                {education.details.map((detail, i) => (
                  <li key={i}>{detail}</li>
                ))}
              </ul>
              <div className="entry__actions">
                <DownloadButton button={education.button} />
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};
